<template>
  <fin-work-in-progess-page title="Sektor-Analyzer"/>
</template>

<script>
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: "FinSektorAnalyzer",
  components: {FinWorkInProgessPage}
}
</script>

<style scoped>

</style>
